export default __webpack_public_path__ + "static/media/mypic.c4112529.jpeg";